/* eslint-disable max-len */
import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react'
import styled from 'styled-components'
import { Modal } from 'reactstrap'

import { Tab } from './tab'
import { ProjectInfo } from './project-info'
import { CostPlanningTab } from './cost-planning'
import { FONTS } from '../../../constants'
import { CloseIcon } from '../../icons'

export default forwardRef((props, ref) => {
  const [activeTab, setActiveTab] = useState(0)
  const [detailState, setDetailState] = useState({})
  const {
    isOpen,
    toggle,
    actions,
    data,
    projectNonService,
  } = props
  const { crType } = data

  useEffect(() => {
    if (projectNonService) {
      setDetailState({
        project_code: projectNonService.project_code,
        vendors: projectNonService.vendors,
        licenses: projectNonService.licenses,
        hardwares: projectNonService.hardwares,
        change_requests: projectNonService.change_requests,
      })
    }
  }, [projectNonService])

  useImperativeHandle(ref, () => ({
    getProjectNonServiceState() {
      const vendors = detailState.vendors.map(v => { return { vendor_id: v.vendor_id, sub_project_code: v.sub_project_code } })
      const licenses = detailState.licenses.map(l => { return { license_id: l.license_id, sub_project_code: l.sub_project_code } })
      const hardwares = detailState.hardwares.map(h => { return { hardware_id: h.hardware_id, sub_project_code: h.sub_project_code } })
      const change_requests = detailState.change_requests.map(c => { return { cr_id: c.cr_id, sub_project_code: c.sub_project_code } })
      return {
        project_code: detailState.project_code,
        vendors,
        licenses,
        hardwares,
        change_requests,
      }
    },
    resetTab() {
      setActiveTab(0)
    },
  }))

  const handleInput = (e, name, idx) => {
    if (name === 'project_code') {
      setDetailState({ ...detailState, [name]: e })
    } else {
      const data = detailState[name]
      data.splice(idx, 1, { ...data[idx], ...e })
      setDetailState({ ...detailState, [name]: data })
    }
  }

  return (
    <Modal size='xl' isOpen={ isOpen } toggle={ toggle }>
      <ModalHeader>
        <Header>Project Information</Header>
        <CloseIcon onClick={ toggle } />
      </ModalHeader>
      <Tab activeTab={ activeTab } setActiveTab={ setActiveTab } />
      <Body>
        { activeTab === 0 &&
          <ProjectInfo
            data={ detailState }
            projectNonService={ projectNonService }
            handleInput={ handleInput }
          />
        }
        { activeTab === 1 &&
          <CostPlanningTab
            data={ detailState }
            crType={ crType }
            handleInput={ handleInput }
          />
        }
      </Body>
      <Footer>{ actions }</Footer>
    </Modal>
  )
})

const ModalHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px 0 16px;
`

const Header = styled.span`
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: ${FONTS.TITLE_SIZE};
  color: #1A1A17;
`

const Body = styled.div`
  display: flex;
  padding: 24px 0;
`

const Footer = styled.div`
  height: 42px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background: #F9F9F9;
  padding: 0 16px;
`



// WEBPACK FOOTER //
// ./src/components/project-code/project-detail/index.js